import React, { useState } from "react";
import "../styles/toggleswitch.css";

/*
Toggle Switch Component
Note: id, checked and onChange are required for ToggleSwitch component to function. The props name, small, disabled
and optionLabels are optional.
Usage: <ToggleSwitch id="id" checked={value} onChange={checked => setValue(checked)}} />
*/

const ToggleSwitch = ({
  id,
  dataTestId,
  onChange
}) => {
  const [value, setValue] = useState("default");

  const onChangeValue = (e) => {
    setValue(e.target.value);
    if(e.target.value === 'default') {
      onChange(null)
      return
    }
    const v = e.target.value == "true" ? true : false;
    onChange(v);
  }

  return (
    <div className="tw-toggle">
        <label for={`${id}_no`} className={value == "false" ? "false" : ""}>No</label>
        <input data-testid={dataTestId} type="radio" id={`${id}_no`} name="toggle" value="false" onChange={onChangeValue} hidden />

        <label for={`${id}_default`} className={value == "default" ? "default minus" : "minus"}><i data-testid="minus" className="fa fa-minus"></i></label>
        <input type="radio" id={`${id}_default`} name="toggle" value="default" onChange={onChangeValue} hidden />

        <label for={`${id}_yes`} className={value == "true" ? "true" : ""} >Yes</label>
        <input type="radio" id={`${id}_yes`} name="toggle" value="true" onChange={onChangeValue} hidden />
        <span></span>  
    </div>  
  );
};

export default ToggleSwitch;
